import { render, staticRenderFns } from "./DeviceClass.vue?vue&type=template&id=31ff7cf8&"
import script from "./DeviceClass.vue?vue&type=script&lang=js&"
export * from "./DeviceClass.vue?vue&type=script&lang=js&"
import style0 from "./DeviceClass.vue?vue&type=style&index=0&id=31ff7cf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports